import { isProduction } from '@/libs/getEnvironment';

const TOP_GAMES_CATEGORY_ID = isProduction()
  ? '8614a166-259a-42a5-b028-38c979226615'
  : '7f49c58a-5f65-4d25-84e3-aef4c67102f9';

const ALL_GAMES_CATEGORY_ID = isProduction() ? '0665160d-d587-4b9a-9d70-e6e0312054f4' : '05cd74f5-e128-4863-853b-cb132ceadc91';
export { ALL_GAMES_CATEGORY_ID, TOP_GAMES_CATEGORY_ID };
